import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'utilities/browserUtils';
import AssetAllocationsTableDesktop from './AssetAllocationsTableDesktop';
import AssetsAllocationsTableMobile from './AssetsAllocationsTableMobile';

const AssetAllocationsTable = ({ colors, data, onMouseEnterRow }) =>
    isMobile() ? (
        <AssetsAllocationsTableMobile
            colors={colors}
            data={data}
            onRowClick={onMouseEnterRow}
        />
    ) : (
        <AssetAllocationsTableDesktop
            colors={colors}
            data={data}
            onMouseEnterRow={onMouseEnterRow}
        />
    );

AssetAllocationsTable.propTypes = {
    colors: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    onMouseEnterRow: PropTypes.func,
};

module.exports = AssetAllocationsTable;
